import { t } from '@hefe/i18n';
import { InventoryApi } from '@hefe/store';
import { fullUserName } from '@hefe/utils';
import { message, Modal } from 'antd';
import { useEffect, useState } from 'react';

interface InventoryShareDetailsModalComponentProps {
  shareId?: string;
}

export default function InventoryShareDetailsModalComponent(
  props: InventoryShareDetailsModalComponentProps
) {
  const { shareId } = props;

  const [fetchDetails, { data: transfer, isFetching: isFetchingDetails }] =
    InventoryApi.useLazyFetchShareLinkDetailsQuery();

  const [confirmTransfer, { isLoading: isConfirmingTransfer }] =
    InventoryApi.useConfirmShareLinkTransferMutation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (shareId) {
      setOpen(true);
      fetchDetails(shareId)
        .unwrap()
        .catch(() => {
          setOpen(false);
        });
    }
  }, [fetchDetails, shareId]);

  const onClickOk = () => {
    if (!transfer?.inventory?.id || !shareId) {
      return;
    }

    confirmTransfer({
      inventoryId: transfer?.inventory?.id,
      shareTransferId: shareId,
    })
      .unwrap()
      .then(() => {
        setOpen(false);
        message.success(
          t('inventory.transfers.share.receive.confirm.description', {
            name: transfer?.inventory?.name,
            from: fullUserName(transfer?.from_user),
          })
        );
      });
  };

  return (
    <Modal
      loading={isFetchingDetails}
      open={open}
      onCancel={() => setOpen(false)}
      onOk={() => onClickOk()}
      okButtonProps={{
        disabled: isFetchingDetails || isConfirmingTransfer,
        loading: isConfirmingTransfer,
      }}
      closable={false}
      title={t('inventory.transfers.share.receive.title')}
    >
      {t('inventory.transfers.share.receive.description', {
        name: transfer?.inventory?.name,
        from: fullUserName(transfer?.from_user),
      })}
    </Modal>
  );
}
